
import React from 'react';
import { Helmet } from 'react-helmet-async';

const AdminProductForm: React.FC = () => {
  // Authentication is now handled by AdminRoute wrapper
  return (
    <>
      <Helmet>
        <title>Product Form - Admin</title>
      </Helmet>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-8">Product Form</h1>
        <div className="bg-card rounded-lg p-6">
          <p className="text-muted-foreground">Product form will be available soon.</p>
        </div>
      </div>
    </>
  );
};

export default AdminProductForm;
